import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "title" }, [
  /*#__PURE__*/_createVNode("h1", null, "Language")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_el_select, {
      placeholder: "Select",
      modelValue: _ctx.setting.language,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.setting.language = $event)),
      loading: _ctx.isLoading
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: language.value,
            label: language.label,
            value: language.value
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "loading"])
  ], 64))
}